<template>
  <div class="link">
    <router-link v-if="isRouterLink" :to="path" :style="{ color: color }">
      <slot>{Link text goes here}</slot>
      <span class="link__underline" :style="{ backgroundColor: color }"></span>
    </router-link>
    <a
      v-else
      :href="path"
      :style="{ color: color }"
      :target="blank ? '_blank' : ''"
    >
      <slot>{Link text goes here}</slot>
      <span class="link__underline" :style="{ backgroundColor: color }"></span>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    path: {
      type: [String, Object],
      required: true
    },
    isRouterLink: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "#266fea"
    },
    blank: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
@import "@/styles/variables.scss";
.link {
  $self: &;
  display: inline-block;
  a {
    display: inline-block;
    font-size: 14px;
    position: relative;
    #{$self}__underline {
      position: absolute;
      display: inline-block;
      height: 1px;
      background: $color-accent;
      left: 0;
      width: 100%;
      bottom: -3px;
      transition: transform 0.32s ease-in;
    }

    &:hover #{$self}__underline {
      transform: scaleX(1.1);
    }
    &:active #{$self}__underline {
      transform: scaleX(0);
    }
  }
}
</style>
